@if (activeCall(); as call) {

<!-- ═══ Appel entrant — maquette ReceptionAppel ═══ -->
@if (call.phase === 'ringing') {
<app-appel-entrant [nom]="call.peerName" [type]="call.type" [photo]="photoInterlocuteur()"
    (repondre)="answer()" (repondreAudioSeul)="answer(true)" (refuser)="decline()" />
}

<!--
  Le son de l'appel vit ICI, pas dans l'écran : un appel minimisé doit continuer à s'entendre.
  Une sortie par participant DISTANT ; jamais la piste de soi-même (larsen).
-->
@if (call.phase === 'active' || call.phase === 'minimized') {
  @for (p of tuilesDistantes(); track p.identity) {
    <app-sortie-audio [piste]="p.audioTrack" (bloque)="sonBloque.set(true)" />
  }
  @if (sonBloque()) {
    <button type="button" (click)="activerSon()"
        class="fixed z-[70] left-1/2 -translate-x-1/2 top-[calc(env(safe-area-inset-top,0px)+12px)] rounded-full px-4 py-2 text-sm font-bold text-white"
        style="background:linear-gradient(160deg,#a5b4fc,#4f46e5);box-shadow:0 12px 24px -8px rgba(79,70,229,0.55)">
      {{ t().calls.enable_sound }}
    </button>
  }
}

<!-- ═══ Appel actif — maquettes Main (à deux) et GroupGrid (3 ou plus) ═══ -->
@if (call.phase === 'active') {
  @if (tuiles().length >= 3) {
    <app-grille-appel-groupe [duree]="elapsed()" [tuiles]="tuiles()"
        (minimiser)="minimize()" (ajouter)="openAddParticipant()" (raccrocher)="endCall()" />
  } @else {
    <app-ecran-appel-actif [nom]="call.peerName" [duree]="elapsed()" [type]="call.type" [tuiles]="tuiles()"
        [initialeInterlocuteur]="initialeDe(call.peerName)" [degradeInterlocuteur]="degradeDe(call.peerName)" [photoInterlocuteur]="photoInterlocuteur()"
        (minimiser)="minimize()" (ajouter)="openAddParticipant()" (raccrocher)="endCall()" />
  }

  <!-- ═══ Ajouter à l'appel — maquette AddParticipant ═══ -->
  @if (showAddParticipant()) {
  <app-ajouter-participant
      [nomAppel]="call.peerName"
      [dejaPresents]="1 + call.invitedNames.length"
      [dansConversation]="colleaguesInConversation()"
      [autres]="otherColleagues()"
      [(recherche)]="colleagueSearch"
      (fermer)="closeAddParticipant()"
      (inviter)="inviteColleagues($event)" />
  }
}

<!-- ═══ Appel actif, minimisé — bandeau persistant pendant la navigation (maquette « Appels — palette claire », écran 3) ═══ -->
@if (call.phase === 'minimized') {
<div class="fixed top-[calc(env(safe-area-inset-top,0px)+56px)] left-3.5 right-3.5 z-40 flex items-center gap-2.5 rounded-2xl py-2 pl-3 pr-2 border
            bg-white border-surface-200 shadow-[0_4px_14px_rgba(15,23,42,0.08)]
            dark:bg-[rgba(28,21,80,0.72)] dark:backdrop-blur-[14px] dark:border-white/10 dark:shadow-[0_16px_32px_-14px_rgba(0,0,0,0.6)]">
    <button type="button" (click)="expand()" [attr.aria-label]="t().calls.tap_to_expand + ' : ' + call.peerName"
        class="flex-1 min-w-0 min-h-[44px] flex items-center gap-2.5 text-left">
        <span class="w-9 h-9 rounded-full overflow-hidden flex items-center justify-center text-xs font-bold flex-none border bg-surface-100 border-surface-200 text-surface-700
                     dark:border-0 dark:text-white dark:bg-[linear-gradient(150deg,#a5b4fc,#4f46e5)] dark:shadow-[0_0_0_4px_rgba(129,140,248,0.16)]">
            <app-photo-appel [photo]="photoInterlocuteur()" [nom]="call.peerName" [initiales]="initialeDe(call.peerName)" />
        </span>
        <span class="min-w-0 flex flex-col">
            <span class="text-[13px] font-bold truncate text-surface-900 dark:text-white">{{ call.peerName }}</span>
            <span class="text-[11px] tabular-nums text-surface-500 dark:text-[#a5a1d6]">{{ elapsed() }} · {{ t().calls.tap_to_expand || 'Tap to expand' }}</span>
        </span>
    </button>
    <button type="button" (click)="endCall()" [attr.aria-label]="t().calls.hang_up"
        class="w-11 h-11 rounded-full flex items-center justify-center flex-none border bg-danger-50 border-danger-200 text-danger-600
               dark:border-0 dark:text-white dark:bg-[linear-gradient(160deg,#fb7185,#e11d48)]">
        <span class="inline-flex rotate-[135deg]" aria-hidden="true"><lucide-icon [img]="Phone" [size]="18"></lucide-icon></span>
    </button>
</div>
}

}

<!-- ═══ Appel terminé — maquette CallEnded ; indépendant de activeCall (déjà remis à null) ═══ -->
@if (lastEndedCall(); as ended) {
<app-appel-termine
    [nom]="ended.peerName"
    [duree]="endedCallDuration()"
    [debut]="ended.startedAt"
    [type]="ended.type"
    [invites]="ended.invitedNames"
    [moi]="moi()"
    [photos]="photosParNom()"
    (fermer)="dismissEnded()"
    (rappeler)="recall()" />
}
